<section [formGroup]="group" class="h-full">
  <div id="header">
    <mat-form-field>
      <input matInput [matDatepickerFilter]="myFilter" formControlName="inputdate" [matDatepicker]="picker"
        [min]="minDate" placeholder="Selectionnez une date">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker startView="month" panelClass="delivery-custom-calendar"></mat-datepicker>
    </mat-form-field>
    <button mat-raised-button color="primary" id="button" (click)="export()" [disabled]="!hasLingePlat">
      Export BL linge plat (PDF)
    </button>
  </div>
  <article>
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td class="list-actions-1" mat-cell *matCellDef="let row">
          <mat-icon (click)="deliveryListCab(row)" *ngIf="isDisplay(row)" matTooltip="Voir plus">visibility</mat-icon>
        </td>
      </ng-container>
      <ng-container *ngFor="let column of columns">
        <ng-container matColumnDef="{{column.id}}">
          <th mat-header-cell *matHeaderCellDef>{{ column.libelle }}</th>
          <td mat-cell [ngClass]="element[column.id] | typeof" *matCellDef="let element">{{ element[column.id] }}</td>
        </ng-container>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </article>
  <article class="h-3/6 flex justify-center items-center" *ngIf="dateList.length == 0 && !load">
    <p>Aucune date disponible</p>
  </article>
</section>